// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleList.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');

  const { map, flow, get, isEmpty, toUpper, reject, escapeRegExp, sortBy, head, invoke, find, filter } = require('lodash/fp');

  var RoleListDetail = require('./Izenda.RoleListDetail');
  var upperCaseName = flow(get('name'), toUpper);

  function RoleList() {
    m.extendObservable(this, {
      roleList: [],
      configRole: new RoleListDetail(),
      filterText: '',
      filterRole: function() {
        var filterRegex = new RegExp(escapeRegExp(this.filterText), 'i');
        var validateName = flow(get('name'), filterRegex.test.bind(filterRegex));

        return flow(filter(validateName), sortBy(upperCaseName))(this.validRole);
      },
      validRole: function() {
        return reject('deleted', this.roleList);
      },
      isEmpty: function() {
        return isEmpty(this.validRole);
      }
    });
  }

  /**
   * read role list from api
   */
  RoleList.prototype.readRoleList = m.action(function(roleList) {
    this.roleList = map(function(role) {
      return new RoleListDetail(role);
    }, roleList);
  });

  RoleList.prototype.findNextRole = m.action(function(role) {
    var oldName = upperCaseName(role);
    var nextRole = find(function(testRole) {
      return upperCaseName(testRole) > oldName;
    }, this.validRole);

    return nextRole || head(this.validRole);
  });

  RoleList.prototype.addRole = m.action(function(role) {
    var newRole = new RoleListDetail(role);

    this.roleList.push(newRole);
    invoke('unselectRole', this.configRole);
    this.configRole = newRole;
    this.configRole.selectRole();
    return newRole;
  });

  RoleList.prototype.selectRole = m.action(function(roleId) {
    var newConfigRole = find(['id', roleId], this.roleList);

    this.configRole.unselectRole();
    newConfigRole.selectRole();
    this.configRole = newConfigRole;
  });

  /**
   * update filter text
   */
  RoleList.prototype.updateFilterText = m.action(function(filterText) {
    this.filterText = filterText;
  });

  module.exports = RoleList;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.RoleList.js